import { useEffect, useLayoutEffect, useState } from 'react';
import { Routes } from 'react-router';
import { Route, useLocation, useSearchParams } from 'react-router-dom';

// import Home from '@/components/Home';
import Login from '@/components/Login';
import Pricing from '@/components/Pricing';
import { CurrentSubscriptionModal } from '@/components/Pricing/currentSubscription';
import { PaymentSuccessModal } from '@/components/Pricing/paymentSuccess';
import { useModals } from '@/hooks/useModals';
import { useGPTStore } from '@/store';
import { removeSearchParam } from '@/utils/tool';

import classes from './index.module.css';

const Container = () => {
  const location = useLocation();
  const { paymentInfo } = useGPTStore();
  const { pathname } = location;

  const [pageHasBg, setPageHasBg] = useState(false);

  useLayoutEffect(() => {
    switch (pathname) {
      case '/':
        setPageHasBg(true);
        break;
      default:
        setPageHasBg(false);
    }
  }, [pathname]);

  const { toggle } = useModals();
  const [params] = useSearchParams();
  const paymentSuccess = params.get('payment') === 'success';
  const paymentCancel = params.get('payment') === 'cancel';

  useEffect(() => {
    // 支付成功：Stripe跳转回来的页面存在 payment=success
    if (paymentSuccess) {
      toggle('paymentSuccessModalOpened', true);
    }
    // 支付取消：显示取消消息并移除URL参数
    if (paymentCancel) {
      removeSearchParam('payment');
    }
  }, [paymentSuccess, paymentCancel]);

  return (
    <>
      <div className={`${classes.Container} ${pageHasBg ? classes.Bg : ''}`}>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/pricing" element={<Pricing />} />
          {/* <Route path="/" element={<Home />} /> */}
        </Routes>
      </div>

      {/* Modal */}
      <PaymentSuccessModal />
      <CurrentSubscriptionModal />
    </>
  );
};

export default Container;
